import {jsPDF} from "jspdf";
import autoTable from "jspdf-autotable";

const FnDownloadPDF = (list, listInclude, titulo, subtitulo = '', isVertical = true) => {
  
  const rowTop = list[0];
  
  const listKeysAll = Object
    .keys(rowTop);
  
  
  const listKeys = listKeysAll
    .filter(k => {
      return listInclude.includes(k);
    })
    .reverse();
  
  const head = [listKeys.map(s => s.toUpperCase())];
  
  const body = list.map(row => {
    const text = listKeys
      .map(key => {
        return row[key]
      })
    return text
  });
  
  const doc = new jsPDF(isVertical ? 'p' : 'l', 'pt', 'letter');
  
  const d = new Date();
  const mes = (d.getMonth() + 1).toString().padStart(2, '0');
  const dia = (d.getDate()).toString().padStart(2, '0');
  doc.setFontSize(11)
  doc.setTextColor(100)
  doc.text(`Vivalia SA de CV SOFOM ENR - ${dia}/${mes}/${d.getFullYear()}`, 40, 24);
  doc.text(`Reporte ${titulo} - ${subtitulo}`, 40, 36);
  
  
  autoTable(doc, {
    head,
    body
  })
  
  doc.save(`${titulo}.pdf`)
  
  
}

export default FnDownloadPDF;